import { NotificationsActions } from './actions';
import { NotificationsState } from './states';
import { Recipe } from 'common/hooks/useProducer';

export const notificationsRecipe: Recipe<
  NotificationsState,
  NotificationsActions
> = (draft, action) => {
  switch (action.type) {
    case 'notifications/started':
      draft.pending = true;
      return;
  }
  switch (action.type) {
    case 'notifications/finished':
      draft.pending = false;
      draft.notifications = action.notifications;
      draft.error = action.error;
      return;
  }
};
